import { render, staticRenderFns } from "./toplukisiekle.vue?vue&type=template&id=651e7814"
import script from "./toplukisiekle.vue?vue&type=script&lang=js"
export * from "./toplukisiekle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports